import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Packages from "./pages/Packages";
import Destination from "./pages/Destination";
import Booking from "./pages/Booking";
import Team from "./pages/Team";
import Testimonial from "./pages/Testimonial";
import Error from "./pages/Error";
import Contact from "./pages/Contact";
import Blog from "./pages/blogs";
import PackageDetails from "./pages/PackageDetails";
import FaqAccordion from "./pages/FaqAccordion";
import ProtectedLayout from "./admin/ProtectedLayout";
import BlogDetails from "./pages/BlogDetails";
import Gallery from "./pages/Gallery";
import HolidayPackageForm from "./pages/Upload";
import ManageHolidayPackages from "./pages/ViewPackages";
import AddService from "./pages/AddService";
import Chatbot from "./chatbot/Chatbot";

import FaqForm from "./admin/FaqForm";
import FaqList from "./admin/FaqList";
import Login from "./admin/Login";
import Signup from "./admin/Signup";
import AdminLayout from "./admin/AdminLayout";
import ClientForm from "./clients/ClientForm";
import ViewClients from "./clients/ViewClients";
import AnalysisDashboard from "./clients/Analytics";
import ServicesManager from "./pages/ManagePrimedaleServies";
import BlogManager from "./pages/BlogManager";
import AdminChatbot from './admin/Chatbot';
import htmlContent from './zohoverify/verifyforzoho.html?raw';
import Quotation from './components/Quotation';
import TestModal from './components/modal';
import Highlights from './pages/Highlights';
import GalleryManagement from "./pages/GalleryManagement";
import UploadReceipt from "./pages/RecieptUpload";

// ===== M-PESA TRANSACTION IMPORTS =====
import MpesaDashboard from './mpesa/pages/Dashboard';
import MpesaUpload from './mpesa/pages/Upload';
import MpesaTransactions from './mpesa/pages/Transactions';
import MpesaAnalytics from './mpesa/pages/Analytics';
import { MpesaProvider } from './mpesa/context/AppContext';

import AdminDashboard from "./admin/AdminDashboard";


//==========Expense Routes =============
import ExpenseDashboard from './admin/expenses/components/Dashboard';
import ExpenseList from './admin/expenses/components/ExpenseList';
import ExpenseForm from './admin/expenses/components/ExpenseForm';
import ExpenseReports from './admin/expenses/components/Reports';

export default function App() {
  const location = useLocation();
  const getCurrentUserId = async () => {
    try {
      const userStr = await localStorage.getItem('currentUser');
      if (!userStr) return 0;
      const user = JSON.parse(userStr);
      console.log(user?.id);

      return user?.id || 0;
    } catch (e) {
      return 0;
    }
  };
  // Hide Header/Footer on admin pages
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Header />}

      <Routes>
        {/* ================= PUBLIC ROUTES ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/destination" element={<Destination />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/team" element={<Team />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/package-details/:slug" element={<PackageDetails />} />
        <Route path="/faqs" element={<FaqAccordion />} />
        <Route path="/faqs/:slug" element={<FaqAccordion />} />
        <Route path="/modal" element={<TestModal />} />
        <Route path="/highlights" element={<Highlights />} />
        <Route path='/gallery' element={<Gallery />} />

        {/* ================= AUTH ROUTES ================= */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/zohoverify/verifyforzoho.html" element={<div dangerouslySetInnerHTML={{ __html: htmlContent }} />} />

        {/* ================= ADMIN DASHBOARD ================= */}
        <Route
          path="/admin"
          element={
            <ProtectedLayout>
              <AdminLayout />
            </ProtectedLayout>
          }
        >
          {/* Existing Admin Routes */}
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="upload-packages" element={<HolidayPackageForm />} />
          <Route path="view-packages" element={<ManageHolidayPackages />} />
          <Route path="add-service" element={<AddService />} />
          <Route path="faqs" element={<FaqList />} />
          <Route path="faqs/new" element={<FaqForm />} />
          <Route path="faqs/edit/:id" element={<FaqForm />} />
          <Route path="manage-services" element={<ServicesManager />} />
          <Route path="blog-manager" element={<BlogManager />} />
          <Route path="quotation" element={<Quotation />} />
          <Route path="client-form" element={<ClientForm />} />
          <Route path="view-clients" element={<ViewClients />} />
          <Route path="view-clients-analytics" element={<AnalysisDashboard />} />
          <Route path="chatbot-queries" element={<AdminChatbot />} />
          <Route path="expenses" element={<ExpenseDashboard />} />
          <Route path="expenses/list" element={<ExpenseList />} />
          <Route path="expenses/new" element={<ExpenseForm />} />
          <Route path="expenses/edit/:id" element={<ExpenseForm />} />
          <Route path="expenses/reports" element={<ExpenseReports />} />

          {/* ===== M-PESA TRANSACTION ROUTES ===== */}
          {/* Wrap M-Pesa routes with MpesaProvider */}
          <Route
            path="mpesa"
            element={
              <MpesaProvider>
                <MpesaDashboard />
              </MpesaProvider>
            }
          />
          <Route
            path="mpesa/upload"
            element={
              <MpesaProvider>
                <MpesaUpload />
              </MpesaProvider>
            }
          />
          <Route
            path="mpesa/transactions"
            element={
              <MpesaProvider>
                <MpesaTransactions />
              </MpesaProvider>
            }
          />
          <Route
            path="mpesa/analytics"
            element={
              <MpesaProvider>
                <MpesaAnalytics />
              </MpesaProvider>
            }
          />
          <Route
            path="gallery"
            element={<GalleryManagement />}
          />
          <Route
            path="upload-receipt"
            element={<UploadReceipt />}
          />
        </Route>
        {/* gallery management */}


        {/* 404 */}
        <Route path="*" element={<Error />} />
      </Routes>

      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <FloatingButton />}
      {!isAdminRoute && <Chatbot />}{/* Global chatbot component */}
    </>
  );
}